export const isValidRange = (
  value: string | undefined | null,
  totalPages: number
): string | null => {
  if (!value || !value.trim()) return null;

  const rangeRegex = /^(\d+(-\d+)?)(,\d+(-\d+)?)*$/;
  if (!rangeRegex.test(value)) {
    return "Неверный формат. Пример: 1-3,5";
  }

  const parts = value.split(",");
  for (const part of parts) {
    if (part.includes("-")) {
      const [start, end] = part.split("-").map(Number);
      if (start < 1 || end < 1 || start > end || end > totalPages) {
        return `Диапазон ${part} вне допустимых страниц (1-${totalPages})`;
      }
    } else {
      const page = Number(part);
      if (page < 1 || page > totalPages) {
        return `Страница ${page} вне диапазона (1-${totalPages})`;
      }
    }
  }

  return null;
};

